import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromProviderDoctorDataStore from './state/provider-doctor-data-store.reducer';

/* effects */
import { ProviderDoctorDataStoreEffects } from './state/provider-doctor-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* ProviderDoctorDataStore State */
    StoreModule.forFeature(
      fromProviderDoctorDataStore.featureKey,
      fromProviderDoctorDataStore.reducer,
      { initialState: fromProviderDoctorDataStore.initialState },
    ),
    EffectsModule.forFeature([ProviderDoctorDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class ProviderDoctorDataStoreModule {}
